import axios from 'axios';

const rawApiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
export const API_BASE = rawApiUrl.endsWith('/api') ? rawApiUrl : `${rawApiUrl.replace(/\/$/, '')}/api`;

export const generateLink = (data) => axios.post(`${API_BASE}/generate-link`, data);
export const fetchLeads = (page = 1) => axios.get(`${API_BASE}/leads?page=${page}`);
export const leadDetails = (leadId) => axios.get(`${API_BASE}/lead-details?id=${leadId}`);
export const submitAssessment = (data) => axios.post(`${API_BASE}/assessment-complete`, data);